var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.778 0.611084C3.54032 0.611084 2.35333 1.10275 1.47816 1.97792C0.602994 2.85309 0.111328 4.04007 0.111328 5.27775V17.7222C0.111328 18.9599 0.602994 20.1469 1.47816 21.022C2.35333 21.8972 3.54032 22.3889 4.778 22.3889H17.2224C18.4601 22.3889 19.6471 21.8972 20.5223 21.022C21.3974 20.1469 21.8891 18.9599 21.8891 17.7222V5.27775C21.8891 4.04007 21.3974 2.85309 20.5223 1.97792C19.6471 1.10275 18.4601 0.611084 17.2224 0.611084H4.778ZM1.66688 5.27775C1.66688 4.45263 1.99466 3.66131 2.57811 3.07786C3.16155 2.49442 3.95288 2.16664 4.778 2.16664H17.2224C18.0476 2.16664 18.8389 2.49442 19.4223 3.07786C20.0058 3.66131 20.3336 4.45263 20.3336 5.27775V17.7222C20.3336 18.5473 20.0058 19.3386 19.4223 19.9221C18.8389 20.5055 18.0476 20.8333 17.2224 20.8333H4.778C3.95288 20.8333 3.16155 20.5055 2.57811 19.9221C1.99466 19.3386 1.66688 18.5473 1.66688 17.7222V5.27775Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckCheckbox);
export default __webpack_public_path__ + "static/media/uncheck_checkbox.b56d4b0a5291be0db86b80775aed40e2.svg";
export { ForwardRef as ReactComponent };